export const bookingSettingsState = {
  bookingSettingsData: null,
  rssList: []
};
